import { createFileRoute } from '@tanstack/react-router';
import { PortalCompany } from '@/features/portal/PortalCompany';

export const Route = createFileRoute('/_portal/portal/azienda')({ component: PortalCompany });
